(async () => {
    const { Core } = await importModule('Core');

    customElements.define('cart-total', class extends Core {
        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
        }

        render() {
            this.subscribe('cart:update', { global: true });
        }

        _cartUpdateHandler(cart) {
            this.textContent = cart.getSubtotal();
        }
    });
})()